import { c as _c } from "react/compiler-runtime";
import { PAYMENT_SETTINGS_API } from 'modules/profile/payment/api/payment-settings-api';
import { UsePaymentSettingsInterface } from 'modules/profile/payment/types/payment-settings-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import useSWR from 'swr';
export function usePaymentSettings(shouldFetch) {
  const $ = _c(8);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher,
    isFetching
  } = useFetch(t0);
  let t1;
  if ($[1] !== shouldFetch || $[2] !== user) {
    t1 = () => {
      if (user && shouldFetch) {
        return PAYMENT_SETTINGS_API;
      }
      return null;
    };
    $[1] = shouldFetch;
    $[2] = user;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    data: paymentSettingsData,
    mutate
  } = useSWR(t1, fetcher);
  let t2;
  if ($[4] !== isFetching || $[5] !== mutate || $[6] !== paymentSettingsData) {
    t2 = {
      paymentSettingsData,
      mutate,
      isFetchingPaymentSettings: isFetching
    };
    $[4] = isFetching;
    $[5] = mutate;
    $[6] = paymentSettingsData;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}